const SMILEY_DATA = {
  grinning_face: '😀',
  grinning_face_with_big_eyes: '😃',
  grinning_face_with_smiling_eyes: '😄',
  beaming_face_with_smiling_eyes: '😁',
  grinning_squinting_face: '😆',
  grinning_face_with_sweat: '😅',
  rolling_on_the_floor_laughing: '🤣',
  face_with_tears_of_joy: '😂',
  slightly_smiling_face: '🙂',
  upside_down_face: '🙃',
  melting_face: '🫠',
  winking_face: '😉',
  smiling_face_with_smiling_eyes: '😊',
  smiling_face_with_halo: '😇',
  smiling_face_with_hearts: '🥰',
  smiling_face_with_heart_eyes: '😍',
  star_struck: '🤩',
  face_blowing_a_kiss: '😘',
  kissing_face: '😗',
  kissing_face_with_closed_eyes: '😚',
  kissing_face_with_smiling_eyes: '😙',
  smiling_face_with_tear: '🥲',
  face_savoring_food: '😋',
  face_with_tongue: '😛',
  winking_face_with_tongue: '😜',
  zany_face: '🤪',
  squinting_face_with_tongue: '😝',
  money_mouth_face: '🤑',
  smiling_face_with_open_hands: '🤗',
  face_with_hand_over_mouth: '🤭',
  face_with_open_eyes_and_hand_over_mouth: '🫢',
  face_with_peeking_eye: '🫣',
  shushing_face: '🤫',
  thinking_face: '🤔',
  saluting_face: '🫡',
  zipper_mouth_face: '🤐',
  face_with_raised_eyebrow: '🤨',
  neutral_face: '😐',
  expressionless_face: '😑',
  face_without_mouth: '😶',
  dotted_line_face: '🫥',
  face_in_clouds: '😶‍🌫️',
  smirking_face: '😏',
  unamused_face: '😒',
  face_with_rolling_eyes: '🙄',
  grimacing_face: '😬',
  face_exhaling: '😮‍💨',
  lying_face: '🤥',
  shaking_face: '🫨',
  head_shaking_horizontally: '🙂‍↔️',
  head_shaking_vertically: '🙂‍↕️',
  relieved_face: '😌',
  pensive_face: '😔',
  sleepy_face: '😪',
  drooling_face: '🤤',
  sleeping_face: '😴',
  face_with_medical_mask: '😷',
  face_with_thermometer: '🤒',
  face_with_head_bandage: '🤕',
  nauseated_face: '🤢',
  face_vomiting: '🤮',
  sneezing_face: '🤧',
  hot_face: '🥵',
  cold_face: '🥶',
  woozy_face: '🥴',
  face_with_crossed_out_eyes: '😵',
  face_with_spiral_eyes: '😵‍💫',
  exploding_head: '🤯',
  cowboy_hat_face: '🤠',
  partying_face: '🥳',
  disguised_face: '🥸',
  smiling_face_with_sunglasses: '😎',
  nerd_face: '🤓',
  face_with_monocle: '🧐',
  confused_face: '😕',
  face_with_diagonal_mouth: '🫤',
  worried_face: '😟',
  slightly_frowning_face: '🙁',
  face_with_open_mouth: '😮',
  hushed_face: '😯',
  astonished_face: '😲',
  flushed_face: '😳',
  pleading_face: '🥺',
  face_holding_back_tears: '🥹',
  frowning_face_with_open_mouth: '😦',
  anguished_face: '😧',
  fearful_face: '😨',
  anxious_face_with_sweat: '😰',
  sad_but_relieved_face: '😥',
  crying_face: '😢',
  loudly_crying_face: '😭',
  face_screaming_in_fear: '😱',
  confounded_face: '😖',
  persevering_face: '😣',
  disappointed_face: '😞',
  downcast_face_with_sweat: '😓',
  weary_face: '😩',
  tired_face: '😫',
  yawning_face: '🥱',
  face_with_steam_from_nose: '😤',
  enraged_face: '😡',
  angry_face: '😠',
  face_with_symbols_on_mouth: '🤬',
  smiling_face_with_horns: '😈',
  angry_face_with_horns: '👿',
  skull: '💀',
  pile_of_poo: '💩',
  clown_face: '🤡',
  ogre: '👹',
  goblin: '👺',
  ghost: '👻',
  alien: '👽',
  alien_monster: '👾',
  robot: '🤖',
  grinning_cat: '😺',
  grinning_cat_with_smiling_eyes: '😸',
  cat_with_tears_of_joy: '😹',
  smiling_cat_with_heart_eyes: '😻',
  cat_with_wry_smile: '😼',
  kissing_cat: '😽',
  weary_cat: '🙀',
  crying_cat: '😿',
  pouting_cat: '😾',
  see_no_evil_monkey: '🙈',
  hear_no_evil_monkey: '🙉',
  speak_no_evil_monkey: '🙊',
  love_letter: '💌',
  heart_with_arrow: '💘',
  heart_with_ribbon: '💝',
  sparkling_heart: '💖',
  growing_heart: '💗',
  beating_heart: '💓',
  revolving_hearts: '💞',
  two_hearts: '💕',
  heart_decoration: '💟',
  heart_exclamation: '❣',
  broken_heart: '💔',
  heart_on_fire: '❤️‍🔥',
  mending_heart: '❤️‍🩹',
  red_heart: '❤️',
  pink_heart: '🩷',
  orange_heart: '🧡',
  yellow_heart: '💛',
  green_heart: '💚',
  blue_heart: '💙',
  light_blue_heart: '🩵',
  purple_heart: '💜',
  brown_heart: '🤎',
  black_heart: '🖤',
  grey_heart: '🩶',
  white_heart: '🤍',
  kiss_mark: '💋',
  hundred_points: '💯',
  anger_symbol: '💢',
  collision: '💥',
  dizzy: '💫',
  sweat_droplets: '💦',
  dashing_away: '💨',
  hole: '🕳',
  speech_balloon: '💬',
  eye_in_speech_bubble: '👁️‍🗨️',
  left_speech_bubble: '🗨',
  right_anger_bubble: '🗯',
  thought_balloon: '💭',
  zzz: '💤',
  waving_hand: '👋',
  raised_back_of_hand: '🤚',
  hand_with_fingers_splayed: '🖐',
  raised_hand: '✋',
  vulcan_salute: '🖖',
  rightwards_hand: '🫱',
  leftwards_hand: '🫲',
  palm_down_hand: '🫳',
  palm_up_hand: '🫴',
  leftwards_pushing_hand: '🫷',
  rightwards_pushing_hand: '🫸',
  ok_hand: '👌',
  pinched_fingers: '🤌',
  pinching_hand: '🤏',
  crossed_fingers: '🤞',
  hand_with_index_finger_and_thumb_crossed: '🫰',
  love_you_gesture: '🤟',
  sign_of_the_horns: '🤘',
  call_me_hand: '🤙',
  backhand_index_pointing_left: '👈',
  backhand_index_pointing_right: '👉',
  backhand_index_pointing_up: '👆',
  middle_finger: '🖕',
  backhand_index_pointing_down: '👇',
  index_pointing_up: '☝',
  index_pointing_at_the_viewer: '🫵',
  thumbs_up: '👍',
  thumbs_down: '👎',
  raised_fist: '✊',
  oncoming_fist: '👊',
  left_facing_fist: '🤛',
  right_facing_fist: '🤜',
  clapping_hands: '👏',
  raising_hands: '🙌',
  heart_hands: '🫶',
  open_hands: '👐',
  palms_up_together: '🤲',
  handshake: '🤝',
  folded_hands: '🙏',
  writing_hand: '✍',
  nail_polish: '💅',
  selfie: '🤳',
  eyes: '👀',
  baby: '👶',
  child: '🧒',
  boy: '👦',
  girl: '👧',
  person: '🧑',
  person_blond_hair: '👱',
  man: '👨',
  person_beard: '🧔',
  man_beard: '🧔‍♂️',
  woman_beard: '🧔‍♀️',
  man_red_hair: '👨‍🦰',
  man_curly_hair: '👨‍🦱',
  man_white_hair: '👨‍🦳',
  man_bald: '👨‍🦲',
  woman: '👩',
  woman_red_hair: '👩‍🦰',
  person_red_hair: '🧑‍🦰',
  woman_curly_hair: '👩‍🦱',
  person_curly_hair: '🧑‍🦱',
  woman_white_hair: '👩‍🦳',
  person_white_hair: '🧑‍🦳',
  woman_bald: '👩‍🦲',
  person_bald: '🧑‍🦲',
  woman_blond_hair: '👱‍♀️',
  man_blond_hair: '👱‍♂️',
  older_person: '🧓',
  old_man: '👴',
  old_woman: '👵',
  person_frowning: '🙍',
  man_frowning: '🙍‍♂️',
  woman_frowning: '🙍‍♀️',
  person_pouting: '🙎',
  man_pouting: '🙎‍♂️',
  woman_pouting: '🙎‍♀️',
  person_gesturing_no: '🙅',
  man_gesturing_no: '🙅‍♂️',
  woman_gesturing_no: '🙅‍♀️',
  person_gesturing_ok: '🙆',
  man_gesturing_ok: '🙆‍♂️',
  woman_gesturing_ok: '🙆‍♀️',
  person_tipping_hand: '💁',
  man_tipping_hand: '💁‍♂️',
  woman_tipping_hand: '💁‍♀️',
  person_raising_hand: '🙋',
  man_raising_hand: '🙋‍♂️',
  woman_raising_hand: '🙋‍♀️',
  deaf_person: '🧏',
  deaf_man: '🧏‍♂️',
  deaf_woman: '🧏‍♀️',
  person_bowing: '🙇',
  man_bowing: '🙇‍♂️',
  woman_bowing: '🙇‍♀️',
  person_facepalming: '🤦',
  man_facepalming: '🤦‍♂️',
  woman_facepalming: '🤦‍♀️',
  person_shrugging: '🤷',
  man_shrugging: '🤷‍♂️',
  woman_shrugging: '🤷‍♀️',
  health_worker: '🧑‍⚕️',
  man_health_worker: '👨‍⚕️',
  woman_health_worker: '👩‍⚕️',
  student: '🧑‍🎓',
  man_student: '👨‍🎓',
  woman_student: '👩‍🎓',
  teacher: '🧑‍🏫',
  man_teacher: '👨‍🏫',
  woman_teacher: '👩‍🏫',
  judge: '🧑‍⚖️',
  man_judge: '👨‍⚖️',
  woman_judge: '👩‍⚖️',
  farmer: '🧑‍🌾',
  man_farmer: '👨‍🌾',
  woman_farmer: '👩‍🌾',
  cook: '🧑‍🍳',
  man_cook: '👨‍🍳',
  woman_cook: '👩‍🍳',
  mechanic: '🧑‍🔧',
  man_mechanic: '👨‍🔧',
  woman_mechanic: '👩‍🔧',
  factory_worker: '🧑‍🏭',
  man_factory_worker: '👨‍🏭',
  woman_factory_worker: '👩‍🏭',
  office_worker: '🧑‍💼',
  man_office_worker: '👨‍💼',
  woman_office_worker: '👩‍💼',
  scientist: '🧑‍🔬',
  man_scientist: '👨‍🔬',
  woman_scientist: '👩‍🔬',
  technologist: '🧑‍💻',
  man_technologist: '👨‍💻',
  woman_technologist: '👩‍💻',
  singer: '🧑‍🎤',
  man_singer: '👨‍🎤',
  woman_singer: '👩‍🎤',
  artist: '🧑‍🎨',
  man_artist: '👨‍🎨',
  woman_artist: '👩‍🎨',
  pilot: '🧑‍✈️',
  fire: '🔥',
};

export default SMILEY_DATA;
